module.exports = __webpack_public_path__ + "img/thumbnail_GiantOtter_f_normal.e8e6fc1a.png";